<template>
	<section>

		<!---Profile Clinic  Content-->
		<div class="profile-clinic layout__box">

			<!--Basic Box-->
			<div class="basic-box">

				<router-link class="basic-link-box" :to="{name: 'Personal'}" v-if="roomId !== id">
					<i class="icon ion-arrow-left-c profile__arrow-icon"></i>
					<a class="basic-link profile__basic-link bold">Вернуться к списку сотрудников</a>
				</router-link>

				<!-- Basic Box Row Wrap -->
				<div class="basic-box__row-wrap">

					<!--Row Item-->
					<div class="basic-box__row hr">
						<div class="basic-box__row-inner">

							<!--Avatar-->
							<div class="basic-box__row-item basic-box__row-item_avatar-wrap">
								<user-avatar :data="workerModel.user" :setClass="'basic-box__avatar'"></user-avatar>
							</div>

							<!--Name-->
							<div class="basic-box__row-item basic-box__row-item_name profile__row-item_mr">
								{{workerModel.user_last_name}} {{workerModel.user_first_name}} {{workerModel.user_middle_name}}
							</div>

							<p class="basic-box__text basic-box__text_size">{{workerModel.position}}</p>

						</div>
					</div>
					<!--Row Item End-->
				</div>
				<!-- Basic Box Row Wrap End -->
			</div>
			<!--Basic Box-->

			<!--Basic Box Item-->
			<div class="basic-box profile-clinic__basic-box">

				<div class="basic-box__inner basic-box__inner_pad profile-clinic__inner flex">
					<div class="basic-box__title basic-box__title_margin">Ведет прием</div>

					<!--Buttons-->
					<div class="basic-box__btns basic-box__btns_placing">
						<button class="basic-box__btn basic-blue-btn profile-clinic__btn" @click="setCan('yes')"
										:class="{'profile-clinic__btn_active': workerModel.can === 'yes'}">
							Свободная запись
						</button>
						<button class="basic-box__btn basic-blue-btn profile-clinic__btn" @click="setCan('by_request')"
										:class="{'profile-clinic__btn_active': workerModel.can === 'by_request'}">
							Запись по заявкам
						</button>
						<button class="basic-box__btn basic-blue-btn profile-clinic__btn" @click="setCan('no')"
										:class="{'profile-clinic__btn_active': workerModel.can === 'no'}">
							Не ведется прием
						</button>
					</div>
					<!--Buttons End-->

				</div>

				<div class="basic-box__inner basic-box__inner_pad flex profile-clinic__inner">
					<div class="basic-box__title basic-box__title_margin">Длительность приема, мин</div>

					<!--Timer-->
					<div class="timer flex profile__timer">

						<div class="timer__minus-btn" @click="decreaseTime">
							<i class="timer__icon icon ion-minus-round"></i>
						</div>

						<div class="timer__time-value">{{workerModel.time}}</div>

						<div class="timer__plus-btn" @click="increaseTime">
							<i class="timer__icon icon ion-plus-round"></i>
						</div>
					</div>
					<!--Timer End-->
				</div>
			</div>
			<!--Basic Box Item End-->

			<!--Basic Box Item-->
			<div class="basic-box profile-clinic__basic-box flex">
				<schedule-editor :schedule="workerModel.schedule"></schedule-editor>

				<!-- <special-day-editor :days="specialDays"></special-day-editor> -->

				<vacation-editor :holidays="specialHolidays"></vacation-editor>
				<div></div>
			</div>
			<!--Basic Box Item End-->

			<!--Basic Box Item-->
			<div class="basic-box profile-clinic__basic-box">

				<div class="basic-box__inner basic-box__inner_pad flex">
					<div class="basic-box__title basic-box__title_margin">Роль в клинике</div>

					<!-- Select -->
					<div class="basic-box__select">
						<select title="title" class="select select_role" v-model="role" :disabled="!Role.isAdmin">
							<option v-for="role in roles" :value="role._id">{{role.name}}</option>
						</select>
					</div>
					<!-- Select End -->

				</div>

				<div class="basic-box__inner basic-box__inner_pad flex">
					<div class="basic-box__title basic-box__title_margin">Должность</div>
					<input class="basic-box__text-field" placeholder="Название должности" type="text"
								 v-model="workerModel.position" :disabled="!Role.isAdmin">
				</div>
			</div>
			<!--Basic Box Item End-->

		</div>
		<!---Profile Clinic Content End-->
	</section>

</template>

<script>
	import moment from 'moment';

	import Role from '@/common/Role';

	import ScheduleEditor from '@/components/ScheduleEditor.vue';
	import SpecialDayEditor from '@/components/SpecialDayEditor.vue';
	import VacationEditor from '@/components/VacationEditor.vue';

	export default {
		name: "Profile",
		components: {ScheduleEditor, SpecialDayEditor, VacationEditor},
		computed: {
			id() {
				return this.$route.params.profile;
			},
			roomId() {
				return this.$route.params.id;
			},
			Role() {
				return new Role(this.$store.state.auth.user, this.$store.state.auth.worker, this.$store.state.auth.clinic);
			},
		},
		mounted() {
			this.$event.connect('updateSchedule', this.getWorker.bind(this));
			this.$event.connect('updateSpecial', this.getSpecial.bind(this));

			this.getWorker();
			this.getSpecial();
		},
		beforeDestroy() {
			this.$event.disconnect(['updateSpecial', 'updateSchedule']);

			if(!this.Role.isAdmin) {
				return false;
			}

			this.workerModel.role_id = this.role;
			this.$store.dispatch('worker/update', this.workerModel);
		},
		data() {
			return {
				workerModel: {},
				roles: [],
				role: '',
				specialDays: [],
				specialHolidays: [],
			}
		},
		methods: {
			getWorker() {
				this.$store.dispatch('worker/get', this.id)
					.then(worker => Promise.all([this.$store.dispatch('role/all', {}), Promise.resolve(worker)]))
					.then(([list, worker]) => {
						this.roles = list;
						this.role = worker.role._id;

						this.workerModel = worker;

						if(this.workerModel.time === undefined) {
							this.$set(this.workerModel, 'time', 5);
						}

						if(this.workerModel.schedule === undefined) {
							this.$set(this.workerModel, 'schedule', [
								{day: 0, period: []},
								{day: 1, period: []},
								{day: 2, period: []},
								{day: 3, period: []},
								{day: 4, period: []},
								{day: 5, period: []},
								{day: 6, period: []},
							]);
						}
					});
			},
			getSpecial() {
				this.$store.dispatch('special/list', {worker_ids: [this.id]})
					.then(special => this.setSpecialData(special));
			},
			increaseTime() {
				if(!this.Role.isAdmin) {
					return false;
				}

				this.workerModel.time = +this.workerModel.time + 5;
			},
			decreaseTime() {
				if(!this.Role.isAdmin) {
					return false;
				}

				if(this.workerModel.time) {
					this.workerModel.time = +this.workerModel.time - 5;
				}
			},
			setSpecialData(response) {
				this.specialDays = [];
				this.specialHolidays = [];

				response.data.map(item => {
					if(moment(item.begin, 'X').format('DD') !== moment(item.end, 'X').format('DD')) {
						this.specialHolidays.push(item)
					} else {
						this.specialDays.push(item)
					}
				})
			},
			setCan(value) {
				if(!this.Role.isAdmin) {
					return false
				}

				this.workerModel.can = value
			},
		},
	}
</script>



// WEBPACK FOOTER //
// Profile.vue?216fbf15